import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { TypographyNormal } from "../../customComponent";
import { colorStyling } from "../../../helpers/color";

const UploadErrorDialog = ({ open, onClose, files, errors }) => {
  const { t } = useTranslation("cms");
  const { t: tCommon } = useTranslation();

  const handleClickClose = () => {
    onClose(false);
  };

  return (
    <>
      <Dialog maxWidth="sm" open={open} fullWidth>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle>{t("uploadError.title")}</DialogTitle>
          </Box>

          <Divider />

          <DialogContent>
            <Box display={"flex"} flexDirection={"column"}>
              <Box display={"flex"}>
                <TypographyNormal
                  sx={{
                    fontSize: "15px",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {t("uploadError.hint")}
                </TypographyNormal>
              </Box>

              <Box display={"flex"}>
                <List>
                  {files.map((file, i) => {
                    return (
                      <ListItem key={i}>
                        <ListItemText
                          primary={`${i + 1}. ${file.name}`}
                          secondary={errors[i]}
                          primaryTypographyProps={{
                            sx: TypographyNormal.defaultProps,
                          }}
                          secondaryTypographyProps={{
                            sx: {
                              pl: 2,
                              fontSize: "12px",
                              fontWeight: 500,
                              color: colorStyling.red,
                            },
                          }}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            </Box>
          </DialogContent>

          <Divider />

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button color="error" variant="outlined" onClick={handleClickClose}>
              {tCommon("closeBtn")}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default UploadErrorDialog;
